module.exports = __webpack_public_path__ + "img/sporting-post.df809676.svg";